import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, Award, BookOpen } from "lucide-react";

export default function SocialProof() {
    return (
        <section className="bg-white py-20 md:py-28" data-testid="social-proof-section">
            <div className="max-w-6xl mx-auto px-6 md:px-12">
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
                    <div className="lg:col-span-7">
                        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#F5A623]/15 border border-[#F5A623]/30 text-xs font-semibold text-[#0A1A2F] mb-5">
                            <span className="w-1.5 h-1.5 bg-[#F5A623] rounded-full" /> KENAPA KAMI ADA
                        </div>
                        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A1A2F] leading-tight tracking-tight">
                            Dibangun dari Pengalaman Nyata Menembus Kampus Global
                        </h2>
                        <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
                            Gantari Edu lahir dari pengalaman langsung melewati proses studi luar negeri, beasiswa, dokumen, dan keputusan besar bersama keluarga. Kami ingin membantu siswa Indonesia mengambil keputusan dengan <strong className="text-[#0A1A2F]">lebih sadar, realistis, dan terarah</strong>.
                        </p>
                        <p className="mt-4 text-sm sm:text-base text-slate-500 italic leading-relaxed border-l-4 border-[#F5A623] pl-4">
                            "Kami percaya kuliah luar negeri bukan hanya soal diterima kampus, tapi memilih jalan yang paling tepat untuk masa depan."
                        </p>
                    </div>

                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="lg:col-span-5"
                    >
                        <div className="bg-gradient-to-br from-[#0A1A2F] to-[#11294A] rounded-3xl p-7 md:p-8 text-white relative overflow-hidden" data-testid="founder-card">
                            <div className="absolute -top-16 -right-16 w-48 h-48 bg-[#F5A623]/20 rounded-full blur-3xl" />
                            <div className="relative">
                                <div className="text-xs uppercase tracking-[0.2em] text-[#F5A623] font-bold mb-4">Founder Gantari Edu</div>
                                <div className="flex items-start gap-4">
                                    <div className="w-16 h-16 rounded-2xl bg-[#F5A623]/15 border border-[#F5A623]/30 flex items-center justify-center flex-shrink-0">
                                        <GraduationCap className="w-7 h-7 text-[#F5A623]" />
                                    </div>
                                    <div>
                                        <div className="font-display font-bold text-2xl">Oki Saputra</div>
                                        <div className="text-sm text-slate-300 mt-1 leading-relaxed">
                                            LPDP Awardee · MSc Innovation & Entrepreneurship, University of Warwick · Founder Gantari Edu
                                        </div>
                                    </div>
                                </div>
                                <div className="grid grid-cols-3 gap-3 mt-6 pt-6 border-t border-white/10">
                                    <div className="text-center">
                                        <Award className="w-5 h-5 text-[#F5A623] mx-auto mb-1.5" />
                                        <div className="text-[10px] uppercase tracking-wider text-slate-400">Beasiswa</div>
                                        <div className="text-xs font-semibold mt-0.5">LPDP</div>
                                    </div>
                                    <div className="text-center">
                                        <GraduationCap className="w-5 h-5 text-[#F5A623] mx-auto mb-1.5" />
                                        <div className="text-[10px] uppercase tracking-wider text-slate-400">Kampus</div>
                                        <div className="text-xs font-semibold mt-0.5">Warwick</div>
                                    </div>
                                    <div className="text-center">
                                        <BookOpen className="w-5 h-5 text-[#F5A623] mx-auto mb-1.5" />
                                        <div className="text-[10px] uppercase tracking-wider text-slate-400">Bidang</div>
                                        <div className="text-xs font-semibold mt-0.5">MSc IE</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
